import { DATE_FORMATS } from "@common/consts/dates";

// Named for the role they play, which DATE_FORMATS' shape-based keys can't express:
// the wire format the API speaks, and the format antd's DatePicker renders. They share
// a value today, but changing one must not change the other.
export const DATE_STRING_FORMAT = DATE_FORMATS.yearMonthDay;
export const DATEPICKER_DATE_FORMAT = DATE_FORMATS.yearMonthDay;

export const MOBILE_APP_PAYWALL_TEXT = "Unsupported on your current plan";

export const FROST_GROWING_ZONES = [
  "1a",
  "1b",
  "2a",
  "2b",
  "3a",
  "3b",
  "4a",
  "4b",
  "5a",
  "5b",
  "6a",
  "6b",
  "7a",
  "7b",
  "8a",
  "8b",
  "9a",
  "9b"
];
export const NO_FROST_GROWING_ZONES = [
  "10a",
  "10b",
  "11a",
  "11b",
  "12a",
  "12b",
  "13a",
  "13b"
];

export const GROWING_ZONES = [...FROST_GROWING_ZONES, ...NO_FROST_GROWING_ZONES];

export const CALENDAR_TASK_FILTER_STORAGE_KEY = "calendar-task-filter";

export const DEFAULT_DEBOUNCE_TIME = 500;

export const DEFAULT_PAGE_SIZE = 25;

export const DAYS_IN_WEEK = 7 as const;

// Injected by the backend via the partials/_backend_values partial, sourced from
// WeatherData::SupportedWindow::SEASONAL_HORIZON_MONTHS. Bounds how far ahead the
// weather-seeding date picker can search.
export const SEEDING_HORIZON_MONTHS = window.SEEDING_HORIZON_MONTHS;

// Injected by the backend via the partials/_backend_values partial, sourced from
// GardenPlans::Geometry::SequenceFit::TIERS.
export const SEQUENCE_FIT_TIERS = window.SEQUENCE_FIT_TIERS;
